module.exports = __webpack_public_path__ + "img/tp-pie.0fa81167.png";